import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/hooks/use-toast';
import { clearOrgScopedUiState } from '@/lib/orgScopedState';
import type { UseClinicSwitchOptions } from '@/types/clinicSwitch';
import { type OrgSwitchState, useOrgSwitch } from '@careflux/auth';

/** The orgs this account may work in, and the move between them. */
export const useClinicSwitch = ({ onEntered }: UseClinicSwitchOptions): OrgSwitchState => {
  const { authAccountId, isAuthenticated, setViewingAsAuthAccountId } = useAuth();
  const { toast } = useToast();

  return useOrgSwitch({
    currentAccountId: authAccountId,
    enabled: isAuthenticated,
    onEntered,
    onSwitched: () => clearOrgScopedUiState(setViewingAsAuthAccountId),
    onError: () => {
      toast({ title: 'Villa', description: 'Ekki tókst að skipta um stofnun', variant: 'destructive' });
    },
  });
};
